module.exports = __webpack_public_path__ + "img/filter-welcome-background-ford.b27479f3.png";